import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/auth/AuthProvider'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { toast } from 'sonner'
import { getEntryPathForUser } from '@/routes/role-routing'

export default function LoginPage() {
  const navigate = useNavigate()
  const { login, status, isAuthenticated, user } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  useEffect(() => {
    if (isAuthenticated) navigate(getEntryPathForUser(user), { replace: true })
  }, [isAuthenticated, navigate, user])

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>Ingreso</CardTitle>
          <CardDescription>Accede al POS</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoComplete="email"
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <Button
            className="w-full"
            disabled={status === 'loading'}
            onClick={async () => {
              try {
                await login(email.trim(), password)
              } catch (e) {
                toast.error('No se pudo iniciar sesión', {
                  description: e instanceof Error ? e.message : undefined,
                })
              }
            }}
          >
            Entrar
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
